import * as React from 'react'

import { Strong } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../common'
import { i18nKeyPrefix } from '../../../../components/school/i18n'
import { SchoolPage_school_reviews } from '../../gql'
import Review from './Review'
import { ReviewsContainer } from './Reviews.styles'

const PRE = `${i18nKeyPrefix}-REVIEWS`

interface IProps {
  reviews: SchoolPage_school_reviews[]
}

export default function Reviews(props: IProps) {
  const { reviews } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <div>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <ReviewsContainer>
        {reviews.map(review => (
          <Review key={review.id} review={review} />
        ))}
      </ReviewsContainer>
    </div>
  )
}
